export enum MenuTrackEventsEnum {
  Accueil = 'Click Accueil',
  Emploi = 'Click Emploi',
  Professionnalisation = 'Click Professionnalisation',
  Apprentissage = 'Click Apprentissage',
  Stages = 'Click Stages',
  Evenement = 'Click Evenement',
  MesuresJeunes = 'Click Mesures Jeunes',
  Entreprises = 'Click Entreprises',
  JobsEte = "Click Jobs d'été",
  JobsEtudiant = 'Click Jobs étudiant',
  Aides = 'Click Aides',
  Mentorat = 'Click Mentorat',
  ServiceSivique = 'Click Service civique',
  Benevolat = 'Click Bénévolat',
  EspaceEmployeur = 'Click Espace employeur',
  MesuresEmployeurs = 'Click Mesures Employeurs',
  Mobilisation = 'Click Mobilisation',
  Recruter = 'Click Recrutement',
  DevenirMentor = 'Click Devenir Mentor',
  Entreprendre = 'Click Entreprendre',
  Formations = 'Click Formation',
  Visiotalent = 'Click Visiotalent',
  Commitment = 'Click Engagement',
  CommitmentOtherOperator = 'Click Autres Dispositifs',
  Sitemap = 'Click Plan du site',
  JobDating = 'Click Jobdating',
}
